/**
 * Styled Components - Created by david on 06/04/18.
 */
import styled from 'styled-components'
import Popover from 'antd/lib/popover'
import { RED_TRANSPARENT, GRAY_DARK, WHITE, BLUE } from '../../theme/colors'
import Button from 'antd/lib/button'

interface ButtonProps {
  secondary?: boolean
  maxMargin?: boolean
}

export const Footer = styled.div`
  padding: 4px;
`

export const DesignName = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: start;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Revenues = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-bottom: 2px;
  margin-top: -2px;
  margin-left: -2px;
`

export const BoldText = styled.div`
  display: flex;
  background: #e1fee0;
  font-size: 9.5px;
  padding: 2px 4px;
  font-family: Avenir;
  border-radius: 3px;
`

export const Upper = styled.span`
  font-weight: bold;
  text-transform: uppercase;
  margin-right: 4px;
`

export const StyledTooltip = styled(Popover)`
  .ant-popover-inner-content {
    padding-top: 1px;
  }
`

export const TextBody = styled.div`
  text-align: center;
  font-size: 13px;
`

export const TooltipBody = styled.div`
  max-width: 314px;
  width: 100%;
  text-align: center;
  margin-top: -4px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const GrossSalesLabel = styled.div`
  font-size: 10px;
  padding: 2px 0px;
  font-weight: 500;
  font-family: Avenir;
  line-height: 1.25;
`

export const DescriptionSection = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

export const LeftDescription = styled.div``

export const ThreeDIcon = styled.img`
  max-width: 26px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: sepia(100%) hue-rotate(170deg) saturate(400%);
    transform: scale(1.2);
  }
`

export const Description = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
  padding 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const HyperLinkCode = styled.div`
  font-size: 12px;
  line-height: 16px;
  padding 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
  cursor: pointer;
  color: ${BLUE};

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const Label = styled.div`
  color: #5f6062;
  padding 4px 0px;
  font-size: 12px;
  line-height: 16px;
  text-align: start;
`

export const Price = styled.div`
  color: #5f6062;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

export const Delete = styled.div`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
`

export const Private = styled.span`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
`

export const ActionButton = styled.div`
  line-height: 16px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #4a90e2;
`

export const ShareContainer = styled.div`
  text-align: right;
`

export const ButtonContainer = styled.div`
  user-select: none;
  display: flex !important;
  align-items: center;
  margin: ${({ maxMargin }: ButtonProps) => (maxMargin ? '8px 0' : '4px 0')};
  width: 100%;
`

export const AddToStoreActionButton = styled(Button)`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? RED_TRANSPARENT : '#fffffff0'};
  color: ${({ secondary }: ButtonProps) => (secondary ? WHITE : GRAY_DARK)};
  font-size: 10px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  transition: all .25s;
  height: 28px;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
    border-color: ${BLUE};
    background-color: ${WHITE};
    color: ${BLUE};
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
  maring-top: 2px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterThumbnailLocker/styledComponents.tsx